export default '/pricing/deals-lp-1001';
